import React from "react";
import ReactTable from "react-table";
import { Link } from 'react-router-dom';
import '../../../stylesheets/shared/react-table.css';
import moment from 'moment-timezone';
import * as Fields from '../../../lis-shared/lis-layout/components/lis-forms-component';
import DatePicker from "react-datepicker";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { journalActionCreators } from '../../../stores/lis-journal-store';
import { sessionActionCreators } from '../../../stores/lis-session-store';
import { cancelRequest } from '../../../services/request.service';
import { navActionCreators } from "../../../stores/lis-nav-store";

class JournalGridComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            journalDate: moment().tz('America/New_York'),
            journalList: [],
            isLoaded: false,
            selected: {},
            sessionList: [],
            sessionDropdown: [],
            selectedSessionToolbar: '',
            selectedSessionGrid: '',
            filtered: [{ id: 'all', value: 'true' }],
            filterAll: 'true',
        };
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleSendCategory = this.handleSendCategory.bind(this);
        this.handleDeleteJournal = this.handleDeleteJournal.bind(this);
    };

    //When component has mounted, make the call to the list users API
    componentDidMount() {
        let selectedSession = this.props.selectedSession;
        let defaultSession = '';
        this.props.actions.getSessionList().then(() => {
            let sessionList = [...this.props.session.sessionList].reverse();
            sessionList.forEach(session => {
                session.label = session.SessionYear + ' ' + session.DisplayName;
                session.value = session.SessionID;
                if (session.IsDefault) {
                    selectedSession = selectedSession || session;
                    defaultSession = session;
                }
            });
            this.setState({
                sessionDropdown: sessionList,
                sessionList: sessionList,
                selectedSessionGrid: defaultSession
            });
            this.props.handleSessionChange(selectedSession, () => this.getJournalData());
        });

        this.props.actions.getJournalCategories();
    }

    componentWillUnmount() {
        cancelRequest();
    }

    getJournalData() {
        if (!this.props.selectedSession) {
            return
        }
        const params = 'sessionID=' + this.props.selectedSession.SessionID;
        this.setState({
            isLoaded: false
        });
        this.props.actions.getJournals(params).then(() => {
            const journalList = this.props.journal.journalList;
            this.setState({
                isLoaded: true,
                journalDate: journalList.find(j => moment(j.JournalDate).tz('America/New_York').isSame(moment().tz('America/New_York'), 'day')) ? null : this.state.journalDate || moment(),
                journalList,
            });
        }).catch(err => {
            if (err === 'Aborted') {
                return;
            }
            this.setState({
                isLoaded: true,
                message: err.toString()
            });
        });
    }

    handleDateChange(date) {
        this.setState({
            journalDate: moment(date).tz('America/New_York')
        });
    }

    handleDropDownChange = (value, state) => {
        this.setState({
            [state]: value
        })
    }

    handleSessionSelectChange = value => {
        this.props.handleSessionChange(value, () => this.getJournalData())
    }

    handleCategoryChange = value => {
        this.props.handleCategoryChange(value);
    }

    onFilteredChange(filtered) {
        if (filtered.length > 1 && this.state.filterAll.length) {
            // NOTE: this removes any FILTER ALL filter
            const filterAll = '';
            this.setState({ filtered: filtered.filter((item) => item.id !== 'all'), filterAll })
        }
        else
            this.setState({ filtered });
    }

    getTrProps = (state, rowInfo, instance) => {
        if (rowInfo) {
            return {
                style: {
                    background: rowInfo.original.IsDefault ? 'rgb(202, 225, 241)' : null,
                }
            }
        }
        return {};
    }

    sendCreateDetails() {
        this.setState({
            isSaving: true
        });
        this.props.actions.buildJournal('?sessionID=' + this.state.selectedSessionGrid.SessionID + '&JournalDay=' + moment(this.state.journalDate).tz('America/New_York').format("MM/DD/yyyy")).then(() => {
            this.setState({
                showCreateSuccess: true,
                isSaving: false
            })
            setTimeout(function () {
                this.setState({ showCreateSuccess: false });
            }.bind(this), 5000);
            this.props.handleSessionChange(this.state.selectedSessionGrid, () => this.getJournalData())
        }).catch(err => {
            if (err === 'Aborted') {
                return;
            }
            this.setState({
                showCreateFailure: true,
                isSaving: false
            });
            setTimeout(function () {
                this.setState({ showCreateFailure: false });
            }.bind(this), 5000);
        });
    }

    handleSendCategory() {
        let params = "journalCategoryType=" + this.props.selectedCategory.label + "&sessionId=" + this.props.selectedSession.SessionID
        this.props.actions.getCategoryData(params)
            .then(() => {
                let downloadLink = document.createElement('a');
                let url = window.URL.createObjectURL(new Blob([this.props.journal.categoryData]))
                downloadLink.setAttribute('href', url);
                downloadLink.setAttribute('download', this.props.selectedSession.label + "-" + this.props.selectedCategory.label + ".mml");

                downloadLink.style.display = 'none';
                document.body.appendChild(downloadLink);
                downloadLink.click();

                document.body.removeChild(downloadLink);
            })
    }

    handleDeleteJournal(journalId) {
        this.props.actions.deleteJournal(journalId)
            .then(() => {
                if (this.props.journal.journalDeleteError.length === 0) {
                    this.props.actions.makeToast([{ message: "Journal Day Deleted", type: "success" }]);
                    this.getJournalData();
                } else {
                    this.props.actions.makeToast([{ message: "Journal Day Delete Failed", type: "failure" }]);
                }
            })
    }

    render() {
        return (
            <div>
                <div className="header-half">
                    <h1>Journal Management</h1>
                </div>
                <div className="toolbar journal-toolbar dlas-forms">
                    <div>
                        <Fields.Dropdown
                            value={this.props.selectedSession}
                            options={this.state.sessionDropdown}
                            id="sessionDropdown"
                            onChange={this.handleSessionSelectChange}
                        />
                    </div>
                    <div>
                        <Fields.Dropdown
                            value={this.props.selectedCategory}
                            options={this.props.journal.journalCategoryList}
                            id="category-dropdown"
                            onChange={this.handleCategoryChange}
                        />
                    </div>
                    <button className="button primary" onClick={() => this.handleSendCategory()}>Generate Category</button>
                </div>
                {this.state.message &&
                    <span className="fail small-text">{this.state.message}</span>
                }
                <ReactTable
                    resizable={false}
                    loading={!this.state.isLoaded}
                    data={this.state.journalList}
                    ref={r => this.reactTable = r}
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value}
                    noDataText={this.props.journal.journalMessage}
                    onFilteredChange={this.onFilteredChange.bind(this)}
                    columns={[
                        {
                            Header: "Journal Date",
                            accessor: "JournalDate",
                            sortable: false,
                            filterAll: true,
                            width: 250,
                            columns: [
                                {
                                    Header: (
                                        <div className="dlas-forms datepicker-container">
                                            {!this.state.showCreateSuccess && !this.state.showCreateFailure &&
                                                <DatePicker
                                                    id="journalDate"
                                                    className="dnd-field"
                                                    selected={this.state.journalDate}
                                                    onChange={this.handleDateChange}
                                                    excludeDates={this.state.journalList.map(j => j.JournalDate)}
                                                    placeholderText="Journal Date"
                                                />
                                            }
                                        </div>
                                    ),
                                    headerClassName: "header-insert",
                                    accessor: "JournalDate",
                                    sortable: false,
                                    filterAll: true,
                                    width: 200,
                                    Cell: row => {
                                        return (
                                            <span id={'cm-datecell-' + row.index}>{moment(row.original.JournalDate).format('L')}</span>
                                        )
                                    }
                                }
                            ]
                        },
                        {
                            Header: "Session",
                            columns: [
                                {
                                    Header: (
                                        <div>
                                            {!this.state.showCreateSuccess && !this.state.showCreateFailure &&
                                                <Fields.Dropdown
                                                    value={this.state.selectedSessionGrid}
                                                    options={this.state.sessionList}
                                                    className="grid-selector-dropdown"
                                                    classNamePrefix="grid-selector-dropdown"
                                                    id="sessionDropdown"
                                                    onChange={(value) => { this.handleDropDownChange(value, 'selectedSessionGrid') }} />
                                            }
                                            {this.state.showCreateSuccess &&
                                                <span className="insert-message">Journal created successfully</span>
                                            }
                                            {this.state.showCreateFailure &&
                                                <span className="insert-message fail">Journal creation failed</span>
                                            }
                                        </div>
                                    ),
                                    headerClassName: "header-insert-dropdown",
                                    accessor: "SessionName",
                                    sortable: false,
                                    filterAll: true,
                                    Cell: row => {
                                        return <span id={'mm-session-' + row.index}>{row.value}</span>
                                    }
                                }
                            ]
                        },
                        {
                            Header: "Actions",
                            headerClassName: "submit-action",
                            columns: [

                                {
                                    Header: (<span><button id="submit-new-journal" onClick={this.sendCreateDetails.bind(this)} disabled={!this.state.journalDate || this.state.isSaving} className="button">Create</button></span>),
                                    headerClassName: "header-action",
                                    accessor: "action",
                                    sortable: false,
                                    className: "action-column",
                                    width: 100,
                                    Cell: row => {
                                        return (
                                            <div className="grid-wrapper two">
                                                <Link id={'cm-edit-' + row.index} to={`/journal-management/edit-journal/${row.original.JournalID}`} className="button edit">Edit</Link>
                                                <span className="icon delete no-repeat" onClick={() => this.handleDeleteJournal(row.original.JournalID)} />
                                            </div>
                                        )
                                    }
                                },
                            ]
                        }
                    ]}
                    defaultSorted={[
                        {
                            id: "Name",
                            desc: false
                        }
                    ]}
                    defaultPageSize={15}
                    pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
                    className="committee-table -striped -highlight"
                />
                <br />

            </div>
        );
    }
}

const JournalManagementGrid = connect(
    (state) => {
        const { journal, session } = state;
        return {
            journal,
            session
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, sessionActionCreators, journalActionCreators, navActionCreators), dispatch)
        }
    }
)(JournalGridComponent)


export default JournalManagementGrid;